import { toast } from 'react-toastify';
import { JAVA_API_STATUS } from '../../../utils/axios-interceptor';
import {
    fetchGstr3bDataService,
    fetchRevenueVendorExpenseTableDataService,
    getGstReportsService,
    generateGstAnalysisReportService,
} from './revenueVendorExpensesService';
import { downloadFile } from '../../../modules/Company/UploadJourney/components/UploadCard/utils/api/helpers';
import { Handlers } from '../../../types/actions/types';

export async function fetchRevenueVendorExpenseTableData(payload, handlers: Handlers) {
    try {
        const response = await fetchRevenueVendorExpenseTableDataService(payload);
        const responseData = response.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                handlers?.onSuccess?.(response?.data?.data || {});
                return;
            case JAVA_API_STATUS.ERROR:
                return toast.error(responseData?.responseMessage || 'Some error occoured');
        }
    } catch (err) {
        handlers?.onError?.();
    }
}

export async function fetchGstr3bData(payload, handlers: Handlers) {
    try {
        const response = await fetchGstr3bDataService(payload);
        const responseData = response.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                handlers?.onSuccess?.(response?.data?.data || {});
                return response?.data?.responseBody;
            case JAVA_API_STATUS.ERROR:
            // return toast.error(responseData?.responseMessage || 'Some error occoured');
        }
    } catch (err) {
        handlers?.onError?.();
    }
}

export async function generateAndDownloadGstAnalysisReport(orgId: string, handlers?: Handlers) {
    try {
        const response = await generateGstAnalysisReportService({ orgId });
        const data = response?.data?.data;
        const mnemosyneDocId = data?.mnemosyneDocId;
        const fileName = data?.fileName;
        if (mnemosyneDocId) {
            await downloadFile(
                mnemosyneDocId,
                () => handlers?.onSuccess?.(data),
                fileName,
                () => handlers?.onError?.(),
            );
        } else {
            toast.error('Failed to generate GST Analysis Report');
            handlers?.onError?.();
        }
    } catch (err) {
        toast.error('Failed to generate GST Analysis Report');
        handlers?.onError?.();
    }
}

export async function getGSTReports(payload, handlers: Handlers) {
    try {
        const response = await getGstReportsService(payload);
        const responseData = response.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                handlers?.onSuccess?.(response?.data?.data || {});
                return response?.data?.gstReports || [];
            case JAVA_API_STATUS.ERROR:
            // return toast.error(responseData?.responseMessage || 'Some error occoured');
        }
    } catch (err) {
        handlers?.onError?.();
    }
}
